module.exports = __webpack_public_path__ + "img/imei_100.0ce56473.png";